export const FastMovingSkuEndpoint = {
  UPLOAD_FAST_MOVING_SKU: '/api/admin/product/fast-moving/upload',
  ACTIVATE_FAST_MOVING_SKU: '/api/admin/product/fast-moving/:version/activate',
  LIST_FAST_MOVING_SKU_VERSIONS: '/api/admin/product/fast-moving/versions',
};
